import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.clients.views.ContactDetailView.';
  public static readonly selectClient = `${Id.prefix}selectClient`;
  public static readonly provideContactName = `${Id.prefix}provideContactName`;
  public static readonly provideEmail = `${Id.prefix}provideEmail`;
  public static readonly provideValidEmail = `${Id.prefix}provideValidEmail`;
  public static readonly contactInfo = `${Id.prefix}contactInfo`;
  public static readonly newPrimaryContact = `${Id.prefix}newPrimaryContact`;
  public static readonly removePrimaryContact = `${Id.prefix}removePrimaryContact`;
  public static readonly client = `${Id.prefix}client`;
  public static readonly labelName = `${Id.prefix}name`;
  public static readonly role = `${Id.prefix}role`;
  public static readonly email = `${Id.prefix}email`;
  public static readonly mobile = `${Id.prefix}mobile`;
  public static readonly primaryContact = `${Id.prefix}primaryContact`;
}

export class LangContactDetailView {
  private constructor() {}

  public static selectClient(): string {
    return interpolate(Id.selectClient);
  }

  public static provideContactName(): string {
    return interpolate(Id.provideContactName);
  }

  public static provideEmail(): string {
    return interpolate(Id.provideEmail);
  }

  public static provideValidEmail(): string {
    return interpolate(Id.provideValidEmail);
  }

  public static contactInfo(): string {
    return interpolate(Id.contactInfo);
  }

  public static newPrimaryContact(): string {
    return interpolate(Id.newPrimaryContact);
  }

  public static removePrimaryContact(): string {
    return interpolate(Id.removePrimaryContact);
  }

  public static client(): string {
    return interpolate(Id.client);
  }

  public static labelName(): string {
    return interpolate(Id.labelName);
  }

  public static role(): string {
    return interpolate(Id.role);
  }

  public static email(): string {
    return interpolate(Id.email);
  }

  public static mobile(): string {
    return interpolate(Id.mobile);
  }

  public static primaryContact(): string {
    return interpolate(Id.primaryContact);
  }
}

export class ContactDetailViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.selectClient, "Please select a {{glossary 'client'}}", 'Validation for selecting a client');
    register.add(Id.provideContactName, "Please provide a {{glossary 'contact'}} Name", 'Validation for contact name');
    register.add(Id.provideEmail, 'Please provide an Email', 'Validation for email');
    register.add(Id.provideValidEmail, 'Please provide a valid Email', 'Validation for valid email');
    register.add(Id.contactInfo, "{{glossary 'contact'}} Info", 'Caption for contact info section');
    register.add(
      Id.newPrimaryContact,
      "This {{glossary 'contact'}} will be the new primary {{glossary 'contact'}} for the {{glossary 'client'}}",
      'Message for new primary contact'
    );
    register.add(
      Id.removePrimaryContact,
      "You are about to remove this {{glossary 'contact'}} as the primary {{glossary 'contact'}} for the {{glossary 'client'}}",
      'Message for removing primary contact'
    );
    register.add(Id.client, "{{glossary 'client'}}", 'Label for client');
    register.add(Id.labelName, 'Name', 'Label for name');
    register.add(Id.role, 'Role', 'Label for role');
    register.add(Id.email, 'Email', 'Label for email');
    register.add(Id.mobile, 'Mobile', 'Label for mobile');
    register.add(Id.primaryContact, "Primary {{glossary 'contact'}}", 'Label for primary contact toggle');
  }
}
